import CreditsPaymentDetailsRow from './CreditsPaymentDetailsRow';

export default CreditsPaymentDetailsRow;
